import { AlertTriangle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { usd } from "@/components/media/ModelPicker";
import EstimateNotes from "@/components/ai/EstimateNotes";

export default function CostSummary({ estimate: e, confirmed, setConfirmed }) {
  const n = (v) => Number(v || 0).toLocaleString("it-IT");
  return (
    <div className="rounded-xl border bg-slate-50/70 p-4" data-testid="dup-cost-summary">
      <p className="text-sm font-semibold text-slate-900">Stima del costo AI</p>
      <dl className="mt-3 space-y-1.5 text-sm">
        <div className="flex justify-between gap-3"><dt className="text-slate-600">Testi e struttura · {e.llm.model}</dt>
          <dd className="tabular-nums text-slate-900" data-testid="dup-cost-llm">{e.llm.usd ? `${usd(e.llm.usd)} · ${n(e.llm.input_tokens)} token in / ${n(e.llm.output_tokens)} out` : "0 $"}</dd></div>
        <div className="flex justify-between gap-3"><dt className="text-slate-600">Immagini AI · {e.images.model}</dt>
          <dd className="tabular-nums text-slate-900" data-testid="dup-cost-images">{e.images.count ? `${e.images.count} × ${usd(e.images.unit_usd)} = ${usd(e.images.usd)}` : "nessuna"}</dd></div>
        <div className="flex justify-between gap-3 border-t pt-2 font-semibold"><dt>Totale stimato</dt>
          <dd className="tabular-nums" data-testid="dup-cost-total">{usd(e.total_usd)}{e.total_usd ? <span className="font-normal text-slate-500"> (max ~{usd(e.max_usd)})</span> : null}</dd></div>
      </dl>
      {e.images.capped && <p className="mt-2 text-[11px] text-slate-500">Massimo {e.images.count} immagini AI per operazione: le altre restano foto stock.</p>}
      <p className="mt-2 text-[11px] text-slate-500">{e.note}</p>
      {e.total_usd > 0 && <div className="mt-2"><EstimateNotes est={e} testid="dup-cost" /></div>}
      {e.over_limit && <p className="mt-2 flex items-center gap-1.5 text-sm text-red-600" data-testid="dup-cost-over-limit"><AlertTriangle size={14} />Oltre il limite per singola operazione ({usd(e.limit_usd)}).</p>}
      {e.total_usd > 0 && !e.over_limit && !e.blocked && (
        <label className="mt-3 flex items-center gap-2 text-sm text-slate-800" data-testid="dup-cost-confirm">
          <Checkbox checked={confirmed} onCheckedChange={(v) => setConfirmed(!!v)} data-testid="dup-cost-confirm-checkbox" />
          Confermo la spesa stimata di circa {usd(e.total_usd)}
        </label>
      )}
    </div>
  );
}
